import type { LucideIcon } from 'lucide-react';
import {
  Accessibility, Activity, AlertCircle, AlertTriangle, Ambulance, Apple, Atom, Baby, BadgeAlert,
  Backpack, Bandage, Bed, Biohazard, Bone, BookMarked, BookOpen, Bookmark, Brain, BrainCircuit,
  BrainCog, BriefcaseMedical, Bug, CalendarHeart, CircleDashed, Clipboard, ClipboardCheck,
  ClipboardList, ClipboardPlus, Cloud, CloudRain, CircleDot, Cross, Dna, Droplet, Droplets,
  Dumbbell, Ear, EarOff, Egg, Eye, FileHeart, Filter, Fingerprint, FlaskConical, FileText, Flame,
  Footprints, Gauge, Glasses, GraduationCap, Hand, HandHeart, Heart, HeartCrack, HeartHandshake,
  HeartPulse, Hospital, Layers, Mars, Microscope, Milestone, Moon, Move, Notebook, Pill,
  PersonStanding, Radar, Radiation, Ribbon, Ruler, Scale, ScanLine, Search, Shield, ShieldAlert,
  ShieldCheck, ShieldOff, ShieldPlus, Skull, Snowflake, Sparkles, SquareActivity, Star,
  Stethoscope, Sun, Syringe, Tablets, TestTube, TestTube2, Thermometer, TrendingDown, TrendingUp,
  Truck, UserRound, Users, UsersRound, Utensils, Venus, VenusAndMars, Waves, Weight, Wind, Zap,
  // ── Adições (expansão de acervo — doenças específicas sem ícone bom até então) ──
  Anchor, AlertOctagon, Ban, Beaker, Carrot, Cigarette, CircleOff, Expand, Factory, Feather,
  GlassWater, LifeBuoy, Magnet, Milk, Palette, PillBottle, Route, Salad, Sandwich, ScanFace,
  Ship, Siren, Soup, SprayCan, TrafficCone, Unlink2, UtensilsCrossed, Wheat, WheatOff,
  // ── Coagulação/trombose/embolia + mais dermatologia ──
  CircleSlash2, Contrast, GitBranch, Grip, Link2,
  // ── Digestório: expansão temática (DRGE, gastrite, úlcera, H. pylori, parasitoses
  // intestinais, hepatites, farmacologia GI, patologia, exames) — ver RYAN_MEDICAL_ICON_GROUPS.digestorio ──
  ChevronsUp, FlameKindling, CircleDotDashed, Spline, Nut, Shuffle, Shell, Worm, Link,
  Puzzle, RefreshCw, Shapes, ArrowDownCircle, Unlink,
  // ── Urogenital (ex-"Urinário", agora unificado com patologia prostática/erétil) +
  // hepatobiliar/pancreático + obstetrícia + novo grupo Ginecológico — ver
  // RYAN_MEDICAL_ICON_GROUPS.urinario/digestorio/obstetricia/ginecologia ──
  Gem, Hourglass, Wine, Scissors,
  // ── Nefrologia (ITU, LRA, DRC, urinálise) + Obstetrícia (diagnóstico da gravidez,
  // pré-natal, Caderneta da Gestante, abortamento, parto) ──
  Bean, Toilet, DropletOff, TestTubes, Pipette, BookHeart, CalendarClock, CalendarCheck,
  NotebookPen, TestTubeDiagonal, ScanHeart, EggOff, BedSingle, Sprout,
} from 'lucide-react';
// Desenhados no estilo Lucide para temas que a Lucide não tem (rim, serpente, gestante...)
import {
  CustomKidney, CustomKidneyStone, CustomUrinaryTract, CustomBladder, CustomGlomerulus,
  CustomSnake, CustomPregnantWoman, CustomUterus, CustomGravidUterus,
} from './ryanCustomIcons';

/**
 * Registro de ícones médicos exclusivo do Ryan — não estende `ICON_MAP`
 * (DeckIconPicker) nem `CYCLE_ICONS` (ExploreContent), que são compartilhados
 * com o GRAIA/ENEM. Usado pelo seletor de ícone dos cards de subdeck e,
 * agora, também pelo seletor de ícone dos campos de estudo (RyanHomePage).
 */
export const RYAN_MEDICAL_ICON_MAP: Record<string, LucideIcon> = {
  Accessibility, Activity, AlertCircle, AlertTriangle, Ambulance, Apple, Atom, Baby, BadgeAlert,
  Backpack, Bandage, Bed, Biohazard, Bone, BookMarked, BookOpen, Bookmark, Brain, BrainCircuit,
  BrainCog, BriefcaseMedical, Bug, CalendarHeart, CircleDashed, Clipboard, ClipboardCheck,
  ClipboardList, ClipboardPlus, Cloud, CloudRain, CircleDot, Cross, Dna, Droplet, Droplets,
  Dumbbell, Ear, EarOff, Egg, Eye, FileHeart, Filter, Fingerprint, FlaskConical, FileText, Flame,
  Footprints, Gauge, Glasses, GraduationCap, Hand, HandHeart, Heart, HeartCrack, HeartHandshake,
  HeartPulse, Hospital, Layers, Mars, Microscope, Milestone, Moon, Move, Notebook, Pill,
  PersonStanding, Radar, Radiation, Ribbon, Ruler, Scale, ScanLine, Search, Shield, ShieldAlert,
  ShieldCheck, ShieldOff, ShieldPlus, Skull, Snowflake, Sparkles, SquareActivity, Star,
  Stethoscope, Sun, Syringe, Tablets, TestTube, TestTube2, Thermometer, TrendingDown, TrendingUp,
  Truck, UserRound, Users, UsersRound, Utensils, Venus, VenusAndMars, Waves, Weight, Wind, Zap,
  Anchor, AlertOctagon, Ban, Beaker, Carrot, Cigarette, CircleOff, Expand, Factory, Feather,
  GlassWater, LifeBuoy, Magnet, Milk, Palette, PillBottle, Route, Salad, Sandwich, ScanFace,
  Ship, Siren, Soup, SprayCan, TrafficCone, Unlink2, UtensilsCrossed, Wheat, WheatOff,
  CircleSlash2, Contrast, GitBranch, Grip, Link2,
  ChevronsUp, FlameKindling, CircleDotDashed, Spline, Nut, Shuffle, Shell, Worm, Link,
  Puzzle, RefreshCw, Shapes, ArrowDownCircle, Unlink,
  Gem, Hourglass, Wine, Scissors,
  Bean, Toilet, DropletOff, TestTubes, Pipette, BookHeart, CalendarClock, CalendarCheck,
  NotebookPen, TestTubeDiagonal, ScanHeart, EggOff, BedSingle, Sprout,
  CustomKidney, CustomKidneyStone, CustomUrinaryTract, CustomBladder, CustomGlomerulus,
  CustomSnake, CustomPregnantWoman, CustomUterus, CustomGravidUterus,
};

export interface RyanMedicalIconGroup {
  id: string;
  label: string;
  icons: string[];
}

// Mesmos ids de sistema usados em RYAN_FIELD_THEMES (grupo "sistemas"), pra
// consistência entre o tema do campo e o agrupamento do picker de ícone —
// mais 4 grupos extras (pediatria, infectologia, exame-clinico, obstetricia)
// que não têm um tema de campo correspondente, só organizam o picker por
// área clínica. "Hematologia/Oncologia" foi unificado dentro de
// "hematologico" (evitar duas abas parecidas com ícones repetidos).
export const RYAN_MEDICAL_ICON_GROUPS: RyanMedicalIconGroup[] = [
  {
    id: 'cardiovascular', label: 'Cardiovascular',
    icons: [
      'Heart', 'HeartPulse', 'HeartCrack', 'HeartHandshake', 'Activity', 'SquareActivity', 'Waves',
      'Stethoscope', 'Droplet', 'Zap', 'Gauge', 'CircleDot', 'ShieldPlus', 'Cross', 'Syringe',
      'Thermometer', 'TrendingUp', 'TrendingDown', 'Baby',
      // Insuficiência venosa/varizes (vaso tortuoso), TVP (estase — âncora/navio parado),
      // DAOP (obstrução arterial — sinalização de bloqueio/claudicação), pericardite (inflamação + alerta)
      'Route', 'Anchor', 'Ship', 'Ban', 'TrafficCone', 'Footprints', 'Flame', 'AlertTriangle',
    ],
  },
  {
    id: 'respiratorio', label: 'Respiratório',
    icons: [
      'Wind', 'Cloud', 'CloudRain', 'Waves', 'Stethoscope', 'ScanLine', 'Radar', 'Snowflake', 'Flame', 'Droplet', 'Thermometer', 'Zap', 'ShieldPlus', 'Cross',
      // Broncoaspiração (alimento/líquido + manobra de resgate/emergência), asma (bombinha),
      // DPOC (tabagismo), derrame pleural (líquido), câncer de pulmão, TB (contágio entre pessoas)
      'Utensils', 'UtensilsCrossed', 'GlassWater', 'LifeBuoy', 'AlertOctagon', 'Siren',
      'SprayCan', 'Cigarette', 'Droplets', 'Ribbon', 'AlertTriangle', 'Users',
    ],
  },
  {
    id: 'neurologico', label: 'Neurológico',
    icons: ['Brain', 'BrainCircuit', 'BrainCog', 'Zap', 'Waves', 'Eye', 'Ear', 'ScanLine', 'CircleDot', 'AlertCircle', 'Sparkles', 'Fingerprint', 'Gauge', 'Radar', 'Stethoscope', 'Cross'],
  },
  {
    id: 'digestorio', label: 'Digestório',
    icons: [
      'Apple', 'Egg', 'Droplet', 'Utensils', 'FlaskConical', 'Filter', 'Stethoscope', 'Thermometer', 'Cross',
      // Nutrição/dieta, exames laboratoriais gerais
      'Salad', 'Soup', 'Sandwich', 'Carrot', 'Wheat', 'Beaker',
      // ── Expansão temática — 1 ícone (no mínimo) por tema, sem repetir entre eles ──
      // Doença do Refluxo Gastroesofágico (conteúdo subindo o esôfago)
      'ChevronsUp',
      // Gastrite (mucosa inflamada)
      'FlameKindling',
      // Úlcera Péptica (cratera/lesão aberta na mucosa)
      'CircleDotDashed',
      // Helicobacter pylori (bactéria espiralada)
      'Spline',
      // Câncer Gástrico
      'Ribbon',
      // Alergia e Intolerância Alimentar (alérgeno clássico)
      'Nut',
      // Doença Inflamatória Intestinal (inflamação crônica)
      'Flame',
      // Síndrome do Intestino Irritável (hábito intestinal errático/alternante)
      'Shuffle',
      // Protozoários Intestinais — Giardíase e Amebíase
      'Shell',
      // Nematódeos: Ancilostomíase e Estrongiloidíase
      'Worm',
      // Nematódeos: Ascaridíase e Enterobiose
      'Route',
      // Esquistossomose Mansônica (ciclo aquático/água doce)
      'Waves',
      // Teníase e Cisticercose (proglotes em cadeia)
      'Link',
      // Diarreia
      'Droplets',
      // Pólipos Colorretais (pequenas saliências na mucosa)
      'Grip',
      // Câncer Colorretal (rastreio por colonoscopia)
      'ScanLine',
      // Hepatites B e C (transmissão parenteral/sanguínea)
      'Syringe',
      // Hepatites A, D e E (transmissão fecal-oral/água contaminada)
      'GlassWater',
      // Hipertensão Portal (aumento de pressão)
      'Gauge',
      // Cirrose Hepática (fibrose em camadas + etilismo, causa clássica)
      'Layers', 'Wine',
      // Pancreatite (enzimas digestivas elevadas + inflamação aguda)
      'TestTube', 'Siren',
      // Abdome Agudo (emergência + sinal de irritação peritoneal ao exame)
      'AlertOctagon', 'Hand',
      // Corpo Estranho em Trato Digestivo (objeto que não pertence ali)
      'Puzzle',
      // Esôfago de Barrett (metaplasia — transformação celular)
      'RefreshCw',
      // Bactéria
      'Bug',
      // Câncer (geral)
      'Skull',
      // Histopatologia (exame microscópico do tecido)
      'Microscope',
      // Anatopatologia/Anatomopatologia (exame macroscópico da peça)
      'Ruler',
      // Morfopatologia (alteração de forma/estrutura)
      'Shapes',
      // Farmacologia
      'Pill',
      // Inibidor da Bomba de Prótons
      'Zap',
      // Laxantes (estímulo ao trânsito/eliminação)
      'ArrowDownCircle',
      // Anticoagulante (rompe a cascata de coagulação)
      'Unlink',
      // Antibiótico
      'ShieldPlus',
      // Teste de H. pylori (teste respiratório da urease)
      'Wind',
      // Teste Sorológico
      'TestTube2',
      // Marcador de Função do Fígado (painel laboratorial)
      'ClipboardList',
      // Lesão Hepática
      'AlertTriangle',
      // Intolerância à Lactose
      'Milk',
      // Doença Celíaca (trigo/glúten cortado)
      'WheatOff',
      // Betalactâmicos e Quinolonas
      'Tablets',
      // Anti-helmínticos e Antiprotozoários
      'PillBottle',
    ],
  },
  {
    // Ex-"Urinário" — renomeado pra "Urogenital" e bem mais rico: agora cobre
    // nefrologia (litíase, LRA, DRC, síndromes nefrítica/nefrótica) e também
    // patologia prostática/erétil masculina, anatomicamente do mesmo sistema.
    id: 'urinario', label: 'Urogenital',
    icons: [
      'Droplet', 'Droplets', 'Filter', 'Waves', 'FlaskConical', 'TestTube2', 'ScanLine', 'Thermometer', 'Stethoscope', 'Cross', 'ShieldPlus', 'Syringe', 'Microscope', 'CircleDot',
      // ITU (bactéria + ardência miccional)
      'Bug', 'Flame',
      // Nefrolitíase (cálculo/pedra + dor em cólica)
      'Gem', 'Zap',
      // Lesão Renal Aguda (creatinina subindo rápido + alerta)
      'TrendingUp', 'AlertTriangle',
      // Doença Renal Crônica (função caindo ao longo do tempo)
      'TrendingDown', 'Hourglass',
      // Síndrome Nefrítica (hematúria/HAS por lesão glomerular inflamatória)
      'Gauge',
      // Síndrome Nefrótica (proteinúria maciça + edema/retenção de líquido)
      'Weight',
      // Hiperplasia Prostática Benigna (próstata aumentada, símbolo masculino)
      'Mars', 'Expand',
      // Disfunção Erétil (falha vascular/neurológica da função)
      'HeartCrack',
      // Rim, Nefrolitíase, Rim e Vias Urinárias, Bexiga (ITU), Glomerulopatias
      'CustomKidney', 'CustomKidneyStone', 'CustomUrinaryTract', 'CustomBladder', 'CustomGlomerulus', 'Bean',
      // ITU (micção), LRA (oligúria/anúria), exame de urina e urocultura
      'Toilet', 'DropletOff', 'TestTubes', 'Pipette',
      // SHU (hemólise — hemácia se rompe)
      'Unlink2',
      // Acidente Ofídico (LRA por veneno; soro antiofídico = 'Syringe' acima)
      'CustomSnake',
      // ITU da Gestante
      'CustomPregnantWoman',
    ],
  },
  {
    id: 'musculoesqueletico', label: 'Musculoesquelético',
    icons: ['Bone', 'Dumbbell', 'Weight', 'PersonStanding', 'Footprints', 'Accessibility', 'ScanLine', 'Cross', 'ShieldPlus', 'Stethoscope', 'Zap', 'Gauge', 'CircleDot', 'Ruler', 'Move'],
  },
  {
    id: 'sentidos', label: 'Sentidos',
    icons: ['Eye', 'Ear', 'EarOff', 'Glasses', 'ScanLine', 'Radar', 'Waves', 'Sparkles', 'CircleDot', 'Search', 'Sun', 'Moon', 'Cross', 'Stethoscope', 'ShieldPlus'],
  },
  {
    id: 'dermatologico', label: 'Dermatológico',
    icons: [
      'Sun', 'Flame', 'Droplet', 'ScanLine', 'Search', 'Sparkles', 'Layers', 'CircleDot', 'Cross', 'ShieldPlus', 'Stethoscope', 'Microscope', 'Thermometer', 'AlertCircle', 'Bug', 'Pill',
      // Pigmentação/tom de pele, prurido, exame de face/pele
      'Palette', 'Feather', 'ScanFace',
      // Dermatite/atópica (predisposição genética + coceira), hanseníase
      // (perda de sensibilidade ao toque + infecção), lúpus (ataque autoimune
      // à pele, fotossensível), vitiligo (perda de pigmento = "sem contraste"),
      // varicela/catapora (rash de múltiplas vesículas, alta transmissão)
      'Dna', 'Hand', 'ShieldAlert', 'Contrast', 'Grip', 'Users',
    ],
  },
  {
    id: 'endocrino', label: 'Endócrino',
    icons: ['FlaskConical', 'TestTube2', 'Droplet', 'Gauge', 'Zap', 'Scale', 'Microscope', 'ClipboardList', 'Cross', 'ShieldPlus', 'Stethoscope', 'Thermometer', 'CircleDot', 'Syringe'],
  },
  {
    // Unificado com o antigo grupo "Hematologia/Oncologia" — um só lugar pra
    // tudo de sangue (anemias, coagulação, oncologia hematológica), evitando
    // duplicar ícones (Droplet, Ribbon, etc.) em duas abas parecidas.
    id: 'hematologico', label: 'Hematológico',
    icons: [
      'Droplet', 'Droplets', 'FlaskConical', 'TestTube2', 'Microscope', 'Syringe', 'Cross', 'ShieldPlus', 'Stethoscope', 'CircleDot', 'Thermometer', 'ClipboardList', 'Filter', 'AlertCircle',
      // Anemia ferropriva (ferro = ímã), megaloblástica (hemácia grande/suplementação B12-folato),
      // hemolítica (hemácia se rompe), eritropoiese (produção — "fábrica" na medula), distúrbios hemorrágicos
      'Magnet', 'Expand', 'PillBottle', 'Unlink2', 'CircleOff', 'Factory', 'Bandage', 'AlertTriangle',
      // Oncologia hematológica (ex-grupo "Hematologia/Oncologia")
      'TrendingDown', 'Ribbon', 'ShieldAlert',
      // Coagulação, trombo, embolia (vaso obstruído pelo coágulo, cascata de
      // fatores, estase que favorece a formação do trombo)
      'Ban', 'CircleSlash2', 'Anchor', 'GitBranch', 'Link2', 'Waves',
    ],
  },
  {
    id: 'reprodutor', label: 'Reprodutor',
    icons: [
      'Baby', 'Venus', 'Mars', 'VenusAndMars', 'Heart', 'UserRound', 'UsersRound', 'Stethoscope', 'ShieldPlus', 'Cross', 'ClipboardList', 'Droplet', 'Microscope', 'Thermometer', 'CircleDot',
      'Egg', 'Milk', 'CustomUterus',
    ],
  },
  {
    id: 'obstetricia', label: 'Obstetrícia',
    icons: [
      // Gravidez (feto/bebê, batimento cardiofetal, calendário gestacional)
      'Baby', 'HeartPulse', 'CalendarHeart', 'Egg',
      // Pré-Natal (acompanhamento em consulta + exames de rotina/imagem)
      'ClipboardList', 'Stethoscope', 'ScanLine', 'Ruler', 'Scale',
      // Parto e Puerpério (via cirúrgica/episiotomia + acolhimento pós-parto)
      'Scissors', 'HandHeart',
      // Aleitamento Materno
      'Milk',
      // Infecções Congênitas — TORCH (patógeno atravessando pra o feto)
      'Bug', 'ShieldAlert',
      // Abortamento (perda gestacional + sangramento)
      'HeartCrack', 'Droplet',
      'Waves', 'UserRound', 'UsersRound', 'ShieldPlus', 'AlertTriangle',
      // Gestação — Fisiologia (gestante, útero gravídico, desenvolvimento fetal)
      'CustomPregnantWoman', 'CustomGravidUterus', 'CustomUterus', 'Sprout',
      // Diagnóstico da gravidez (β-hCG) + USG obstétrica/BCF
      'TestTubeDiagonal', 'ScanHeart',
      // Primeira consulta de pré-natal, Caderneta da Gestante, idade gestacional e agenda de consultas
      'NotebookPen', 'BookHeart', 'CalendarClock', 'CalendarCheck',
      // Risco Gestacional
      'Gauge',
      // Abortamento (perda gestacional) e Parto
      'EggOff', 'BedSingle',
    ],
  },
  {
    // Novo grupo — patologias ginecológicas fora do ciclo gravídico (fica
    // separado de "Obstetrícia" e do "Reprodutor" genérico/anatômico).
    id: 'ginecologia', label: 'Ginecológico',
    icons: [
      'Venus', 'Stethoscope', 'ScanLine', 'Cross', 'ShieldPlus', 'Microscope', 'CircleDot',
      // Doenças da Mama (fita de conscientização + nódulo + mamografia)
      'Ribbon',
      // Climatério e Menopausa (declínio hormonal + fogachos)
      'TrendingDown', 'Flame',
      // Corrimento Vaginal e Uretral (secreção + agente infeccioso)
      'Droplets', 'Bug',
      // Úlceras Genitais (lesão/cratera aberta na mucosa + curativo)
      'CircleDotDashed', 'Bandage',
      // HPV (vírus + material genético + lesões verrucosas múltiplas)
      'Dna', 'Grip',
      'AlertCircle',
      'CustomUterus',
    ],
  },
  {
    id: 'imunologico', label: 'Imunológico',
    icons: ['Shield', 'ShieldPlus', 'ShieldCheck', 'ShieldAlert', 'Biohazard', 'Radiation', 'Bug', 'BadgeAlert', 'Thermometer', 'Syringe', 'Cross', 'Stethoscope', 'Microscope', 'FlaskConical', 'AlertTriangle'],
  },
  {
    id: 'pediatria', label: 'Pediatria',
    icons: [
      'Baby', 'PersonStanding', 'Backpack', 'TrendingUp', 'Milestone', 'Sparkles', 'HeartPulse',
      'Gauge', 'ShieldOff', 'ClipboardList', 'Stethoscope', 'Thermometer', 'Bug', 'Bandage',
    ],
  },
  {
    id: 'infectologia', label: 'Infectologia',
    icons: [
      'Bug', 'CircleDashed', 'Biohazard', 'Wind', 'Flame', 'Thermometer', 'Microscope', 'FlaskConical',
      'TestTube', 'TestTube2', 'ShieldAlert', 'ShieldPlus', 'Syringe', 'Droplet', 'AlertTriangle',
      // TB: transmissão aérea entre pessoas (contágio)
      'Users',
      // HIV/AIDS (fita de conscientização + imunodeficiência)
      'Ribbon',
    ],
  },
  {
    id: 'exame-clinico', label: 'Exame Clínico',
    icons: [
      'Stethoscope', 'Notebook', 'ClipboardList', 'ClipboardCheck', 'Hand', 'Eye', 'Ear', 'Gauge',
      'ScanLine', 'Thermometer', 'Search', 'Ruler', 'Scale', 'Droplets',
    ],
  },
  {
    id: 'geral', label: 'Geral',
    icons: [
      'BookOpen', 'BookMarked', 'ClipboardList', 'Clipboard', 'ClipboardCheck', 'ClipboardPlus',
      'Search', 'AlertCircle', 'Stethoscope', 'Cross', 'Truck', 'Ambulance', 'Hospital',
      'BriefcaseMedical', 'HandHeart', 'Bandage', 'FileHeart', 'Tablets', 'TestTube', 'Skull',
      'CalendarHeart', 'Dna', 'Atom', 'Bed', 'GraduationCap', 'Users', 'UsersRound', 'Scale',
      'FileText', 'Star', 'Bookmark', 'ShieldOff', 'Hand', 'Notebook', 'Ribbon', 'Milestone',
      'Backpack',
    ],
  },
];

export function getRyanMedicalIcon(iconId?: string | null): LucideIcon | null {
  if (!iconId) return null;
  return RYAN_MEDICAL_ICON_MAP[iconId] || null;
}

// Nome em PT-BR de cada ícone, pra exibir no tooltip do seletor (RyanSubdeckIconPicker)
// em vez do nome cru do componente Lucide (em inglês). Cobre todo RYAN_MEDICAL_ICON_MAP.
export const RYAN_MEDICAL_ICON_LABELS_PT: Record<string, string> = {
  Accessibility: 'Mobilidade reduzida',
  Activity: 'Atividade/Pulso',
  AlertCircle: 'Alerta',
  AlertTriangle: 'Alerta importante',
  Ambulance: 'Ambulância',
  Apple: 'Nutrição',
  Atom: 'Átomo',
  Baby: 'Bebê',
  BadgeAlert: 'Selo de alerta',
  Backpack: 'Mochila',
  Bandage: 'Curativo',
  Bed: 'Internação',
  Biohazard: 'Risco biológico',
  Bone: 'Osso',
  BookMarked: 'Livro marcado',
  BookOpen: 'Livro aberto',
  Bookmark: 'Marcador',
  Brain: 'Cérebro',
  BrainCircuit: 'Cérebro (circuito)',
  BrainCog: 'Cérebro (engrenagem)',
  BriefcaseMedical: 'Maleta médica',
  Bug: 'Micro-organismo',
  CalendarHeart: 'Calendário/Coração',
  CircleDashed: 'Contorno tracejado',
  Clipboard: 'Prancheta',
  ClipboardCheck: 'Prancheta aprovada',
  ClipboardList: 'Lista/Prontuário',
  ClipboardPlus: 'Prancheta médica',
  Cloud: 'Nuvem',
  CloudRain: 'Chuva',
  CircleDot: 'Ponto/Lesão',
  Cross: 'Cruz médica',
  Dna: 'DNA/Genética',
  Droplet: 'Gota',
  Droplets: 'Gotas',
  Dumbbell: 'Halter',
  Ear: 'Orelha',
  EarOff: 'Surdez',
  Egg: 'Óvulo',
  Eye: 'Olho',
  FileHeart: 'Ficha médica',
  Filter: 'Filtro',
  Fingerprint: 'Impressão digital',
  FlaskConical: 'Frasco de laboratório',
  FileText: 'Documento',
  Flame: 'Inflamação',
  Footprints: 'Pegadas',
  Gauge: 'Medidor',
  Glasses: 'Óculos',
  GraduationCap: 'Formatura',
  Hand: 'Mão',
  HandHeart: 'Cuidado',
  Heart: 'Coração',
  HeartCrack: 'Coração partido',
  HeartHandshake: 'Acolhimento',
  HeartPulse: 'Pulso cardíaco',
  Hospital: 'Hospital',
  Layers: 'Camadas',
  Mars: 'Símbolo masculino',
  Microscope: 'Microscópio',
  Milestone: 'Marco/Etapa',
  Moon: 'Lua',
  Move: 'Movimento',
  Notebook: 'Caderno',
  Pill: 'Comprimido',
  PersonStanding: 'Pessoa em pé',
  Radar: 'Radar',
  Radiation: 'Radiação',
  Ribbon: 'Fita de conscientização (oncologia/HIV)',
  Ruler: 'Régua',
  Scale: 'Balança/Peso',
  ScanLine: 'Exame de imagem',
  Search: 'Busca/Investigação',
  Shield: 'Escudo',
  ShieldAlert: 'Escudo de alerta',
  ShieldCheck: 'Escudo protegido',
  ShieldOff: 'Sem proteção',
  ShieldPlus: 'Escudo médico',
  Skull: 'Gravidade/Risco',
  Snowflake: 'Frio',
  Sparkles: 'Brilho',
  SquareActivity: 'Monitor cardíaco',
  Star: 'Estrela',
  Stethoscope: 'Estetoscópio',
  Sun: 'Sol',
  Syringe: 'Seringa',
  Tablets: 'Comprimidos',
  TestTube: 'Tubo de ensaio',
  TestTube2: 'Tubo de ensaio',
  Thermometer: 'Termômetro',
  TrendingDown: 'Queda',
  TrendingUp: 'Aumento',
  Truck: 'Transporte',
  UserRound: 'Pessoa',
  Users: 'Pessoas (contágio)',
  UsersRound: 'Grupo de pessoas',
  Utensils: 'Talheres',
  Venus: 'Símbolo feminino',
  VenusAndMars: 'Símbolos feminino/masculino',
  Waves: 'Fluxo/Ondas',
  Weight: 'Peso',
  Wind: 'Vento/Ar',
  Zap: 'Choque/Impulso',
  Anchor: 'Âncora (estase)',
  AlertOctagon: 'Sinal de perigo',
  Ban: 'Bloqueio',
  Beaker: 'Béquer',
  Carrot: 'Cenoura',
  Cigarette: 'Cigarro',
  CircleOff: 'Célula destruída',
  Expand: 'Expansão',
  Factory: 'Produção (fábrica)',
  Feather: 'Coceira/Leveza',
  GlassWater: 'Copo d’água',
  LifeBuoy: 'Resgate/Emergência',
  Magnet: 'Ímã (ferro)',
  Milk: 'Leite/Amamentação',
  Palette: 'Pigmentação',
  PillBottle: 'Frasco de remédio',
  Route: 'Trajeto tortuoso',
  Salad: 'Salada',
  Sandwich: 'Sanduíche',
  ScanFace: 'Exame facial',
  Ship: 'Navio (estase)',
  Siren: 'Sirene/Emergência',
  Soup: 'Sopa',
  SprayCan: 'Spray/Bombinha',
  TrafficCone: 'Obstrução',
  Unlink2: 'Ruptura',
  UtensilsCrossed: 'Engasgo/Aspiração',
  Wheat: 'Trigo',
  WheatOff: 'Sem glúten',
  CircleSlash2: 'Vaso obstruído',
  Contrast: 'Despigmentação',
  GitBranch: 'Cascata de fatores',
  Grip: 'Manchas/Pontos',
  Link2: 'Elo/Fator de ligação',
  ChevronsUp: 'Refluxo (subida)',
  FlameKindling: 'Mucosa inflamada',
  CircleDotDashed: 'Lesão/cratera aberta',
  Spline: 'Bactéria espiralada',
  Nut: 'Alérgeno alimentar',
  Shuffle: 'Hábito intestinal alternante',
  Shell: 'Protozoário',
  Worm: 'Verme',
  Link: 'Proglotes em cadeia',
  Puzzle: 'Corpo estranho',
  RefreshCw: 'Metaplasia (transformação celular)',
  Shapes: 'Alteração de forma/estrutura',
  ArrowDownCircle: 'Trânsito/eliminação',
  Unlink: 'Rompe a coagulação',
  Gem: 'Cálculo (pedra)',
  Hourglass: 'Cronicidade (tempo)',
  Wine: 'Etilismo (álcool)',
  Scissors: 'Parto cirúrgico/episiotomia',
  Bean: 'Rim (estilizado)',
  Toilet: 'Micção/urina',
  DropletOff: 'Oligúria/anúria',
  TestTubes: 'Exame de urina',
  Pipette: 'Coleta/urocultura',
  BookHeart: 'Caderneta da Gestante',
  CalendarClock: 'Idade gestacional',
  CalendarCheck: 'Consulta agendada',
  NotebookPen: 'Primeira consulta/anamnese',
  TestTubeDiagonal: 'Teste de gravidez (β-hCG)',
  ScanHeart: 'USG/batimento cardiofetal',
  EggOff: 'Perda gestacional',
  BedSingle: 'Parto/internação',
  Sprout: 'Desenvolvimento/crescimento',
  CustomKidney: 'Rim',
  CustomKidneyStone: 'Nefrolitíase (rim com cálculo)',
  CustomUrinaryTract: 'Rins e vias urinárias',
  CustomBladder: 'Bexiga',
  CustomGlomerulus: 'Glomérulo',
  CustomSnake: 'Serpente (acidente ofídico)',
  CustomPregnantWoman: 'Gestante',
  CustomUterus: 'Útero',
  CustomGravidUterus: 'Útero gravídico (feto)',
};

export function getRyanMedicalIconLabel(iconId: string): string {
  return RYAN_MEDICAL_ICON_LABELS_PT[iconId] || iconId;
}
